import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export type TooltipProps = PropsWithChildren & {
   label: string;
};

/**
 * Tooltip component that works with Link components.
 * @param {TooltipProps} props - Props for the tooltip.
 * @returns {JSX.Element} The Tooltip component.
 */
export const Tooltip = ({ children, label }: TooltipProps): JSX.Element => {
   return (
      <Box position="relative" display="inline-block" role="group">
         {children}
         <Box
            position="absolute"
            bottom="100%"
            left="50%"
            transform="translateX(-50%)"
            mb="2"
            px="2"
            py="1"
            bg="blueGray.800"
            color="white"
            fontSize="sm"
            borderRadius="md"
            whiteSpace="nowrap"
            opacity={0}
            pointerEvents="none"
            transition="opacity 0.2s"
            _groupHover={{ opacity: 1 }}
         >
            {label}
         </Box>
      </Box>
   );
};
